/**
 * Met à jour le CTA « Ajouter au panier » du panneau produit quand on bascule
 * abonnement / achat unique ou change de fréquence (theme.js ne le fait pas).
 * S’appuie sur script[data-product-selection-pricing] injecté dans le panneau.
 */
(function () {
  var DOC_LISTENERS = "__regloCtaLiveDocListeners";
  var SUBSCRIPTION_CLASS = "componentCta--productPanelSubscription";
  var FALLBACK_SUB = "AJOUTER EN ABONNEMENT";
  var FALLBACK_ONE = "Ajouter au panier";

  function ctaLabelsFromPanel(panel) {
    var sub = panel.getAttribute("data-cta_label_subscription");
    var one = panel.getAttribute("data-cta_label_one_time");
    return {
      sub: sub && sub.length ? sub : FALLBACK_SUB,
      one: one && one.length ? one : FALLBACK_ONE,
    };
  }

  function parsePricing(panel) {
    var el = panel.querySelector("script[data-product-selection-pricing]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents, formatHint) {
    var c = Number(cents);
    if (Number.isNaN(c)) return "";
    if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(c, formatHint || "{{amount}}");
    }
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    }).format(c / 100);
  }

  function subscriptionModeFromDom(panel) {
    var sub = panel.querySelector('[data-id="subscriptionSelector"]');
    if (sub) return sub.hasAttribute("data-is_selected");
    return panel.getAttribute("data-subscription_is_selected") === "true";
  }

  function selectedPlanId(panel) {
    var holder = panel.querySelector('[data-id="subscriptionPlanSelector"]');
    if (!holder) return "";
    var sel =
      holder.querySelector("select.componentSelect__field[data-id=fullLabels]") ||
      holder.querySelector("select.componentSelect__field");
    return sel && sel.value ? String(sel.value) : "";
  }

  /**
   * Variante courante : le thème met souvent à jour data-selected sur la ligne
   * sans toucher à data-selected_variant_id du panneau — on lit donc le DOM.
   */
  function selectedVariantIdFromDom(panel) {
    var sel = panel.querySelector(
      '[data-id="variantSelectors"] .componentProductSelectionPanel__variant[data-selected]:not([data-hidden])'
    );
    if (sel) {
      var id = sel.getAttribute("data-variant_id");
      if (id) return String(id);
    }
    sel = panel.querySelector(
      '.componentProductSelectionPanel__stickyPanel__variant[data-selected]:not([data-hidden])'
    );
    if (sel) {
      var idSticky = sel.getAttribute("data-variant_id");
      if (idSticky) return String(idSticky);
    }
    sel = panel.querySelector(
      '[data-id="dogSizeVariantSelectors"] .componentProductSelectionPanel__dogSizeSelector[data-selected]'
    );
    if (sel) {
      var ent = sel.getAttribute("data-entity_id");
      if (ent) return String(ent);
    }
    return String(panel.getAttribute("data-selected_variant_id") || "");
  }

  /** Dernier palier applicable (même logique que le Liquid du sélecteur de quantité). */
  function bulkDiscountPercent(tiers, qty) {
    if (!tiers || !tiers.length) return 0;
    var q = parseInt(qty, 10);
    if (q < 1 || Number.isNaN(q)) q = 1;
    var pct = 0;
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      if (q >= (t.min || 0)) pct = Number(t.pct) || 0;
    }
    return Math.min(100, Math.max(0, pct));
  }

  /**
   * Prix unitaire après remise volume, arrondi à l’euro-cent (entiers uniquement,
   * évite les erreurs float). Aligné sur le panier : arrondi par unité × quantité,
   * pas un seul arrondi sur le total ligne.
   */
  function discountedUnitCents(unitCents, pct) {
    var u = Math.round(Number(unitCents));
    if (!Number.isFinite(u) || u <= 0) return 0;
    var p = Math.min(100, Math.max(0, Math.round(Number(pct))));
    var num = u * (100 - p);
    return Math.floor((num + 50) / 100);
  }

  function lineTotalCents(unitCents, qty, pct) {
    var q = Math.max(1, parseInt(qty, 10) || 1);
    return discountedUnitCents(unitCents, pct) * q;
  }

  function selectedQuantityFromDom(panel, variantId) {
    var wrap =
      panel.querySelector('[data-id="quantitySelector"][data-selected]') ||
      (variantId
        ? panel.querySelector(
            '[data-id="quantitySelector"][data-variant_id="' + variantId + '"]'
          )
        : null) ||
      panel.querySelector('[data-id="quantitySelector"]');
    if (!wrap) return 1;
    var sel =
      wrap.querySelector("select.componentSelect__field[data-id=fullLabels]") ||
      wrap.querySelector("select.componentSelect__field");
    var raw = sel && sel.value ? parseInt(sel.value, 10) : 1;
    return raw > 0 ? raw : 1;
  }

  function updatePanelBuyCta(panel, data) {
    if (!data || !data.variants) return;

    var variantId = selectedVariantIdFromDom(panel);
    var v = data.variants[variantId];
    if (!v) return;

    var subscriptionMode = subscriptionModeFromDom(panel);
    var cta = panel.querySelector('[data-id="inPagePanel"] [data-id="cta"]');
    if (!cta) return;

    var newEl = cta.querySelector('[data-id="newPrice"]');
    var origEl = cta.querySelector('[data-id="originalPrice"]');
    var textEl = cta.querySelector(".componentCta__text");
    var hint = data.moneyWithCurrencyFormat || "{{amount}}";
    var labels = ctaLabelsFromPanel(panel);

    var qty = selectedQuantityFromDom(panel, variantId);
    var tiers = v.bulkDiscount || [];
    var pct = bulkDiscountPercent(tiers, qty);

    var newCents;
    var origCents = null;
    var showStrikethrough = false;

    if (subscriptionMode && v.plans && Object.keys(v.plans).length) {
      var planId = selectedPlanId(panel);
      var subUnit =
        planId && v.plans[planId] != null ? v.plans[planId] : null;
      if (subUnit == null) {
        var planIds = Object.keys(v.plans);
        subUnit = v.plans[planIds[0]];
      }
      newCents = lineTotalCents(subUnit, qty, pct);
      var oneTimeLine = lineTotalCents(v.oneTime, qty, pct);
      origCents = oneTimeLine;
      showStrikethrough = oneTimeLine > newCents;
      if (textEl) textEl.textContent = labels.sub;
      cta.classList.add(SUBSCRIPTION_CLASS);
      cta.setAttribute("data-with_price", "");
      if (showStrikethrough) {
        cta.setAttribute("data-with_original_price", "");
      } else {
        cta.removeAttribute("data-with_original_price");
      }
    } else {
      newCents = lineTotalCents(v.oneTime, qty, pct);
      if (textEl) textEl.textContent = labels.one;
      cta.classList.remove(SUBSCRIPTION_CLASS);
      cta.setAttribute("data-with_price", "");
      var cmpAt =
        v.compareAt != null && v.compareAt !== ""
          ? Number(v.compareAt)
          : NaN;
      var one = Number(v.oneTime);
      if (!Number.isNaN(cmpAt) && !Number.isNaN(one) && cmpAt > one) {
        var cmpInt = Math.round(cmpAt);
        origCents = cmpInt * qty;
        showStrikethrough = true;
        cta.setAttribute("data-with_original_price", "");
      } else {
        origCents = null;
        showStrikethrough = false;
        cta.removeAttribute("data-with_original_price");
      }
    }

    if (newEl) newEl.textContent = formatMoney(newCents, hint);
    if (origEl) {
      origEl.textContent =
        showStrikethrough && origCents != null && !Number.isNaN(Number(origCents))
          ? formatMoney(origCents, hint)
          : "";
    }

    panel.setAttribute("data-subscription_is_selected", subscriptionMode ? "true" : "false");
    if (subscriptionMode) {
      var pid = selectedPlanId(panel);
      if (pid) panel.setAttribute("data-selected_subscription_plan_id", pid);
    }
  }

  function schedule(panel, data) {
    setTimeout(function () {
      updatePanelBuyCta(panel, data);
    }, 0);
  }

  function wirePanel(panel) {
    var data = parsePricing(panel);
    if (!data) return;

    var mo = new MutationObserver(function () {
      schedule(panel, data);
    });
    mo.observe(panel, {
      attributes: true,
      attributeFilter: ["data-selected_variant_id", "data-selected_product_id"],
    });

    var freqRoot = panel.querySelector(
      ".componentProductSelectionPanel__frequencySelectors"
    );
    if (freqRoot) {
      mo.observe(freqRoot, {
        attributes: true,
        subtree: true,
        attributeFilter: ["data-is_selected"],
      });
    }

    var variantRoot = panel.querySelector('[data-id="variantSelectors"]');
    if (variantRoot) {
      mo.observe(variantRoot, {
        attributes: true,
        subtree: true,
        attributeFilter: ["data-selected", "data-hidden"],
      });
    }

    var stickyVarRoot = panel.querySelector(
      ".componentProductSelectionPanel__stickyPanel__variants"
    );
    if (stickyVarRoot) {
      mo.observe(stickyVarRoot, {
        attributes: true,
        subtree: true,
        attributeFilter: ["data-selected", "data-hidden"],
      });
    }

    var dogSizeRoot = panel.querySelector('[data-id="dogSizeVariantSelectors"]');
    if (dogSizeRoot) {
      mo.observe(dogSizeRoot, {
        attributes: true,
        subtree: true,
        attributeFilter: ["data-selected"],
      });
    }

    panel.querySelectorAll('[data-id="quantitySelector"]').forEach(function (root) {
      mo.observe(root, {
        attributes: true,
        attributeFilter: ["data-selected"],
      });
    });

    schedule(panel, data);
  }

  function bindDocumentListenersOnce() {
    if (window[DOC_LISTENERS]) return;
    window[DOC_LISTENERS] = true;

    document.addEventListener(
      "click",
      function (e) {
        var freq = e.target.closest(
          ".componentProductSelectionPanel__frequencySelectors__selector"
        );
        if (freq) {
          var panel = freq.closest('[data-component="productSelectionPanel"]');
          if (!panel) return;
          var data = parsePricing(panel);
          if (data) schedule(panel, data);
          return;
        }
        var variantRow = e.target.closest(
          '.componentProductSelectionPanel__variant[data-id="selector"], .componentProductSelectionPanel__stickyPanel__variant[data-id="selector"], .componentProductSelectionPanel__dogSizeSelector[data-id="selector"]'
        );
        if (variantRow) {
          var panelV = variantRow.closest(
            '[data-component="productSelectionPanel"]'
          );
          if (!panelV) return;
          var dataV = parsePricing(panelV);
          if (dataV) schedule(panelV, dataV);
        }
      },
      true
    );

    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t.matches || !t.matches("select.componentSelect__field")) return;
      var panel = t.closest('[data-component="productSelectionPanel"]');
      if (!panel) return;
      if (
        !t.closest('[data-id="subscriptionPlanSelector"]') &&
        !t.closest('[data-id="quantitySelector"]')
      ) {
        return;
      }
      var data = parsePricing(panel);
      if (data) schedule(panel, data);
    });
  }

  function init() {
    document
      .querySelectorAll('[data-component="productSelectionPanel"]')
      .forEach(function (panel) {
        if (panel.getAttribute("data-reglo-cta-live-wired")) return;
        panel.setAttribute("data-reglo-cta-live-wired", "1");
        wirePanel(panel);
      });
    bindDocumentListenersOnce();
  }

  init();
  try {
    window.addEventListener("ig:ready", init);
  } catch (e) {}
})();
